export default __webpack_public_path__ + "static/media/Velocity-Home_15.68e3ec4a.jpg";